import { render, staticRenderFns } from "./addlabel.vue?vue&type=template&id=1967f744&scoped=true&"
import script from "./addlabel.vue?vue&type=script&lang=js&"
export * from "./addlabel.vue?vue&type=script&lang=js&"
import style0 from "./addlabel.vue?vue&type=style&index=0&id=1967f744&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1967f744",
  null
  
)

export default component.exports